import React, { useMemo } from 'react';
import { Button, useApi } from '@axiom/ui';
import type { Candidate, User } from '@axiom/validation';

import { CandidateApi } from '../../api/candidate-api';
import { isLoggedInUser } from '../../utils/roles-util';

export type FavoriteButtonProps = {
  user: User | null;
  candidate: Pick<Candidate, 'id' | 'isViewOnly'>;
};
export const FavoriteButton: React.FC<FavoriteButtonProps> = ({
  user,
  candidate,
}) => {
  const [{ data: savedCandidates } = { data: [] }] = useApi(
    isLoggedInUser(user) ? CandidateApi.readFavoriteCandidates() : undefined
  );

  const isSaved = useMemo(
    () =>
      savedCandidates.some(({ candidateId }) => candidateId === candidate.id),
    [candidate, savedCandidates]
  );

  const handleOnClick = async () => {
    await (isSaved
      ? CandidateApi.deleteSavedCandidate(candidate.id)
      : CandidateApi.createSavedCandidate(candidate.id));
    await CandidateApi.refreshFavoriteCandidates();
  };

  return (
    <Button
      name="favorite-button"
      variation="minimal"
      icon={isSaved ? 'star-filled' : 'star'}
      onClick={handleOnClick}
      disabled={candidate.isViewOnly}
    >
      {isSaved ? 'Saved' : 'Save'}
    </Button>
  );
};
